import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsRoadmapRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-roadmap',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
	exact: true,
};
